import { Component, inject } from '@angular/core';
import { ActionCardConfigInterface, BrightsideUiModule } from '@brightside/brightside-ui';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { routePath } from '@brightside-web/desktop/data-access/core-services';

@Component({
    selector: 'brightside-web-survey-action-card',
    imports: [BrightsideUiModule],
    templateUrl: './survey-action-card.component.html',
    styleUrl: './survey-action-card.component.css'
})
export class SurveyActionCardComponent {
  data: { surveyType: string | undefined };
  actionCardConfig: ActionCardConfigInterface;

  private _translateSvc = inject(TranslateService);
  private _router = inject(Router);

  ngOnInit() {
    this.actionCardConfig = {
      label: this._translateSvc.instant('TAKE_ACTION'),
      labelSub: this._translateSvc.instant('SURVEY_EMONEY_MINUTES'),
      title: this._translateSvc.instant('SURVEY_EMONEY_TITLE'),
      body: this._translateSvc.instant('SURVEY_EMONEY_DESC'),
      cardStyle: 'small',
      labelIcon: 'icon-actions',
      labelSubRemoveDash: true,
      marginBottom: 'small',
    };
  }

  navigate() {
    if (this.data?.surveyType) {
      this._router.navigate(['survey', this.data?.surveyType, 'view']);
    } else {
      this._router.navigate([routePath('survey_info_view')]);
    }
  }
}
